var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { ArrowUpTrayIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { Translate } from "../../../I18N";
import { formatBytes } from "../../shared/formatHelpers";







const FileDropzone = ({ className, onDrop, onChange }) => {
  const [files, setFiles] = useState([]);
  const [totalSize, setTotalSize] = useState(0);

  useEffect(() => {
    let result = 0;

    files.forEach((file) => {
      result += file.size;
    });

    setTotalSize(result);

    if (onChange) {
      onChange(files);
    }
  }, [files]);

  const removeFile = (index) => {
    setFiles(files.filter((_file, i) => i !== index));
  };

  const handleOnDrop = (acceptedFiles, fileRejections, event) => {
    if (acceptedFiles) {
      setFiles([...files, ...acceptedFiles]);
    }
    if (onDrop) {
      onDrop(files, fileRejections, event);
    }
  };

  return /*#__PURE__*/(
    _jsx(Dropzone, { onDrop: handleOnDrop }, void 0,
    ({ getRootProps, getInputProps }) => /*#__PURE__*/
    _jsx("section", {
      className: `p-4 bg-gray-50 rounded border border-gray-300 border-dashed ${className}` }, void 0, /*#__PURE__*/

    React.createElement("div", getRootProps(), /*#__PURE__*/
    React.createElement("input", getInputProps()), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx(ArrowUpTrayIcon, { className: "m-auto w-auto text-gray-200 max-w-20" }), /*#__PURE__*/

    _jsx("div", { className: "leading-6 text-center" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "font-semibold border-b-2 border-black cursor-pointer" }, void 0, "Browse files to upload"

    ), "\xA0", /*#__PURE__*/

    _jsx(Translate, {}, void 0, "or drop your files here.")
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex flex-wrap gap-2 my-4" }, void 0,
    files.map((file, index) => /*#__PURE__*/
    _jsx("div", {


      className: "text-sm border border-gray-300 bg-gray-100 px-[2px] rounded flex flex-nowrap gap-1 align-middle" }, `${file.name}-${index}`, /*#__PURE__*/

    _jsx("span", { className: "truncate max-w-32" }, void 0, file.name), /*#__PURE__*/
    _jsx("span", {}, void 0, "-"), /*#__PURE__*/
    _jsx("span", { className: "whitespace-nowrap" }, void 0, formatBytes(file.size)), /*#__PURE__*/
    _jsx("button", { type: "button", onClick: () => removeFile(index) }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "sr-only" }, void 0, "Delete"), /*#__PURE__*/
    _jsx(XMarkIcon, { className: "w-4" })
    )
    )
    )
    ),

    files.length > 0 && /*#__PURE__*/
    _jsx("div", { className: "text-sm" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Size"), ": ", formatBytes(totalSize)
    )

    )

    ));

};

export { FileDropzone };